import React from 'react';

/**
 * 사이드바 공통 리스트 컴포넌트
 * 원본 sidebar-common-list.html을 React로 변환
 */
const SidebarCommonList = () => {
  const listItems = [
    {
      id: 1,
      title: '리스트형 사이드바',
      subtitle: '리스트 스타일의 사이드바 컨텐츠입니다. 썸네일 이미지와 함께 표시됩니다.',
      thumbnail: null
    },
    {
      id: 2,
      title: '리스트 아이템 2',
      subtitle: '각 아이템은 썸네일 이미지와 텍스트로 구성됩니다. 이미지가 없으면 플레이스홀더가 표시됩니다.',
      thumbnail: null
    },
    {
      id: 3,
      title: '리스트 아이템 3',
      subtitle: '호버 시 테마 색상으로 강조되며, 항목의 높이가 더 커졌습니다.',
      thumbnail: null
    },
    {
      id: 4,
      title: '리스트 아이템 4',
      subtitle: '테마 색상에 맞춰 자동으로 스타일이 적용되며, 썸네일 이미지 영역이 좌측에 배치됩니다.',
      thumbnail: null
    }
  ];

  return (
    <>
      <style>{`
        .sidebar-common-list .list-item {
          display: flex;
          align-items: center;
          padding: 16px;
          margin-bottom: 12px;
          min-height: 90px;
          background: color-mix(in srgb, var(--theme-color-surface, #ffffff) 92%, transparent);
          border-left: 3px solid var(--theme-color-primary);
          border-radius: 8px;
          transition: all 0.2s ease;
          cursor: pointer;
        }
        .sidebar-common-list .list-item:hover {
          background: color-mix(in srgb, var(--theme-color-primary) 12%, transparent);
          transform: translateX(4px);
          border-left-width: 4px;
          box-shadow: 0 4px 12px color-mix(in srgb, var(--theme-color-primary) 15%, transparent);
        }
        .sidebar-common-list .list-item-thumbnail {
          width: 70px;
          height: 70px;
          border-radius: 8px;
          background: linear-gradient(135deg,
            color-mix(in srgb, var(--theme-color-primary) 20%, var(--theme-color-surface, #ffffff)),
            color-mix(in srgb, var(--theme-color-primary) 10%, var(--theme-color-surface, #ffffff))
          );
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 14px;
          flex-shrink: 0;
          overflow: hidden;
          border: 2px solid color-mix(in srgb, var(--theme-color-primary) 15%, transparent);
        }
        .sidebar-common-list .list-item-thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
        .sidebar-common-list .list-item-thumbnail .thumbnail-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--theme-color-primary);
          font-weight: 700;
          font-size: 24px;
          background: linear-gradient(135deg,
            color-mix(in srgb, var(--theme-color-primary) 15%, transparent),
            color-mix(in srgb, var(--theme-color-primary) 8%, transparent)
          );
        }
        .sidebar-common-list .list-item-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 70px;
        }
        .sidebar-common-list .list-item-title {
          font-size: 15px;
          font-weight: 600;
          color: var(--theme-color-text-strong, #2f3a5e);
          margin-bottom: 6px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sidebar-common-list .list-item-subtitle {
          font-size: 13px;
          color: var(--theme-color-text-muted, #6d7691);
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
      <div className="sidebar-common-list">
        {listItems.map((item) => (
          <div key={item.id} className="list-item">
            <div className="list-item-thumbnail">
              {item.thumbnail ? (
                <img src={item.thumbnail} alt={item.title} />
              ) : (
                <div className="thumbnail-placeholder">
                  {String(item.id).padStart(2, '0')}
                </div>
              )}
            </div>
            <div className="list-item-content">
              <div className="list-item-title">{item.title}</div>
              <div className="list-item-subtitle">{item.subtitle}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SidebarCommonList;

